import { queryOptions } from "@tanstack/react-query";
import {
  fetchProjects,
  fetchProjectBySlug,
  fetchProjectsByCategory,
  fetchAllProjectsWithCategories,
} from "./projects.functions";

export const allProjectsQueryOptions = queryOptions({
  queryKey: ["projects", "all"],
  queryFn: () => fetchAllProjectsWithCategories(),
  staleTime: 60_000,
});

export const projectsQueryOptions = queryOptions({
  queryKey: ["projects", "websites"],
  queryFn: () => fetchProjects(),
  staleTime: 60_000,
});

export const projectsByCategoryQueryOptions = (slug: string) =>
  queryOptions({
    queryKey: ["projects", "category", slug],
    queryFn: () => fetchProjectsByCategory({ data: { slug } }),
    staleTime: 60_000,
  });

export const projectBySlugQueryOptions = (slug: string) =>
  queryOptions({
    queryKey: ["projects", "websites", slug],
    queryFn: () => fetchProjectBySlug({ data: { slug } }),
    staleTime: 60_000,
  });

export type { Project } from "./types";
